import { Helmet } from "react-helmet";
import { Img, Text, Heading } from "../../components";
import Footer from "components/Footer";
import HomePageIntroductionSection from "./HomePageIntroductionSection";
import HomePageSection from "./HomePageSection";
import Navbar from "components/Navbar";
import React from "react";export default function WebsitehomePage() {
  
  return (
    <>
      <Helmet>
        <title>Home - Revolutionizing Portfolio Risk Management | Tail Risk Global</title>
        <meta
          name="description"
          content="Welcome to Tail Risk Global, the forefront of portfolio risk management. Explore our proprietary methodology for illiquid assets and on-the-fly rebalancing. Join us and revolutionize your investment strategy."
        />
      </Helmet>
      <div className="w-full bg-gray-300">
        <div className="relative h-screen bg-gray-300">
          <Img
            src="images/img_bg_graphics.png"
            alt="Background Graphics"
            className="absolute bottom-0 left-0 top-0 my-auto h-[760px] w-[92%] object-contain"
          />
          <div className="absolute left-0 right-0 top-6 m-auto flex flex-1 flex-col items-center gap-[35px] md:gap-[30px] sm:gap-[20px]">
            <div className="container-xs md:px-5">
              <Navbar />
            </div>
            
            {/* Show Message about beta version */}
            <div className="flex flex-col w-full max-w-[1240px]">
              <div className="flex w-full justify-end max-w-[1240px] px-[22px]">
              <Heading
                  size="headings"
                  as="h3"
                  className="relative top-3 text-[30px] font-semibold leading-[140%] text-blue_gray-900 md:text-[34px] sm:text-[32px]"
                >
                  <a href="/BetaVersion" className="text-pink-a200 cursor-pointer">Test our Beta version now!</a>

                  <a href="/scheduleDemo" className="text-pink-a200 text-center cursor-pointer">Schedule a Demo! </a>

                </Heading>

              </div>

            </div>
            {/* home page section */}
            <HomePageSection />
          </div>
        </div>


        {/* home page introduction section */}
        <HomePageIntroductionSection />

        <div>
            <Footer />
        </div>
      </div>
    </>
  );
}


